import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isTriggered: {},
};

export const globalActionsSlice = createSlice({
  name: 'GlobalActions',
  initialState: initialState,
  reducers: {
    triggerPrintPdf: (state, action) => {
      state.isTriggered = action.payload;
    },
  },
});

export const { triggerPrintPdf } = globalActionsSlice.actions;
const globalActions = globalActionsSlice.reducer;
export default globalActions;
